import React, { useEffect, useState } from "react";
import "./OffersPage.css";
import { useSelector, useDispatch } from "react-redux";
import { setOffers } from "../../../../../store/app/appReducer";
import callApi from "../../../../../utility/apiCaller";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { setUserClickData } from "../../../../../utility/setUserClickData";
import OfferCard from "./OfferCard";
import { useSearchParams } from "react-router-dom";
import _ from "lodash";

// ── Thank You screen ──
const IIFL_ID    = "69a2c7ab1f6f4ddfd5577314";
const MUTHOOT_ID = "69ea0b864084a68bdadc40bd";

const ThankYouScreen = ({ lenders, isLoading }) => (
  <div className="gdl-ty-page">

    <div className="gdl-ty-hero">
      <img src="/assets/img/Group385-thankyou.png" className="thank-you-offer" />
      <p className="gdl-ty-sub">We've received your details</p>
    </div>

    <p className="gdl-ty-section-title">What's Next?</p>

    <div className="gdl-ty-card">
      {isLoading ? (
        // ── Loading state ──
        <div className="gdl-ty-loading">
          <div className="gdl-ty-spinner" />
          <p className="gdl-ty-loading-text">We are fetching your offers…</p>
        </div>
      ) : lenders.length > 0 ? (
        // ── Has lenders ──
        <>
          <div className="gdl-ty-call-row">
              <div className="gdl-ty-call-title"><img src="assets/img/Group 399.png"/>Expect a Call Soon</div>
          </div>

          <div className="gdl-ty-sent-box">
            <p className="gdl-ty-sent-label">We have sent your details to</p>
            <div className="gdl-ty-lender-row">
              {lenders.map((lender) => (
                <div key={lender.lender_id} className="gdl-ty-lender-badge">
                  {lender.lender_id === IIFL_ID ? (
                    <img src="/assets/img/iifl626.png" alt="IIFL Finance" className="gdl-ty-lender-logo" />
                  ) : lender.lender_id === MUTHOOT_ID ? (
                    <img src="/assets/img/muthoot629.png" alt="Muthoot Finance" className="gdl-ty-lender-logo" />
                  ) : null}
                </div>
              ))}
            </div>
          </div>

          <p className="gdl-ty-card-footer">
            Their team will reach out shortly to understand your requirement and
            help take things forward.
          </p>
        </>
      ) : (
        <div className="gdl-ty-no-offer-box">
          <p className="gdl-ty-no-offer">There is no offer for you currently.</p>
        </div>
      )}
    </div>
  </div>
);

// ── Main OffersPage ──────────────────────────────────────────
const OfferPage = ({ formData = {}, setShowOfferHeaderLogo }) => {
  const lead = useSelector((state) => state.app.lead);
  const user = useSelector((state) => state.app.user);
  const offers = useSelector((state) => state.app.offers);
  const dispatch = useDispatch();
  const [isFinished, setIsFinished] = useState(false);
  const [leadId, setLeadId] = useState();
  const [expandedOfferId, setExpandedOfferId] = useState(null);
  const [activeLenders, setActiveLenders] = useState([]);
  const [thankYouLenders, setThankYouLenders] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [params] = useSearchParams();
  const [isTncChecked, setIsTncChecked] = useState(true);
  const mobile = formData?.mobile || "";
  const navigate = useNavigate();
  const [source, setSource] = useState("");
  const token = user?.token;
  const [leadData, setLeadDate] = useState({});
  const [failedList, setFailedList] = useState([]);
  const ldId = params.get("ld_id") || "";
  const utmMedium = params.get("utm_medium") || "";
  const [ipAddress, setIpAddress] = useState("");

  async function fetchIp() {
    await fetch("https://api.ipify.org?format=json")
      .then((response) => response.json())
      .then((data) => {
        setIpAddress(data?.ip);
      })
      .catch((error) => {
        console.log("Error:", error);
      });
  }

  useEffect(() => {
    fetchIp();
  }, []);

  useEffect(() => {
    fetchActiveLenders();
  }, []);

  useEffect(() => {
    dispatch(setOffers([]));
  }, []);

  useEffect(() => {
    if (formData?.stepDone === 3 && !leadId) {
      submitLead();
    }
  }, [formData]);

  useEffect(() => {
    if (offers.length > 0 && !expandedOfferId) {
      setExpandedOfferId(offers[0]._id);
    }
  }, [offers]);

  useEffect(() => {
    if (typeof setShowOfferHeaderLogo !== "function") return;
    setShowOfferHeaderLogo(offers.length === 0);
  }, [offers]);

  const fetchActiveLenders = async () => {
    try {
      const res = await callApi(`v1/lender/active-lenders`, "get", {}, "loan");
      if (res.status === "Success") {
        const apiLenders = res.data.lenderList ?? [];
        setActiveLenders(apiLenders);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const submitLead = async () => {
    setUserClickData({
      event_name: "submit-gold-loan-v1",
      user_id: mobile || "No User ID found here",
      affiliate_id: params.get("aff_id") || "No Aff_id found",
      utm_medium: utmMedium,
    });
    try {
      const leadResponse = await callApi(
        "v1/lead/lead-from-phone",
        "post",
        {
          phone: mobile,
          website_kyc_consent: isTncChecked,
          website_kyc_consent_datetime: new Date().toISOString(),
          kyc_consent: isTncChecked,
          kyc_consent_datetime: new Date().toISOString(),
        },
        "core",
        token,
      );

      if (leadResponse["status"] === "Success" && leadResponse.data.lead) {
        const leadData = leadResponse.data.lead;
        setLeadDate(leadData);
        await callApi(
          "v1/lead/list",
          "post",
          { filters: { _id: leadData._id } },
          "core",
        );
        setIsLoading(true);
        setTimeout(() => {
          fetchOffers(leadData._id);
        }, 6000);
      } else {
        navigate(`/personal-loan?source=${source}`);
      }
    } catch (error) {
      console.log("Error fetching lead or calling APIs:", error);
      setIsFinished(true);
      navigate(`/personal-loan?source=${source}`);
    }
  };

  const fetchOffers = async (leadId) => {
    if (!leadId || isFinished) return false;

    const startTime = Date.now();

    try {
      const [offerRes, lenderRes] = await Promise.all([
        callApi(`v1/loan_offer/lead_id/${leadId}`, "get", {}, "core", user.token),
        callApi(`v1/lender/active-lenders`, "get", {}, "loan", user.token),
      ]);

      let filteredOffers = [];

      if (
        offerRes.status === "Success" &&
        offerRes.data?.offers?.length > 0 &&
        lenderRes.status === "Success"
      ) {
        const offers = offerRes.data.offers;
        const apiLenders = lenderRes.data.lenderList ?? [];

        const lenderListRes = await callApi(
          `v1/lender_api_call/${leadId}/get-fail-success-lenders`,
          "post",
          {},
          "loan",
          user.token,
        );

        if (Array.isArray(lenderListRes.data?.FailList)) {
          setFailedList(lenderListRes.data.FailList);
        }

        const successLenders =
          lenderListRes.status === "Success" &&
          Array.isArray(lenderListRes.data?.Successlist)
            ? lenderListRes.data.Successlist
            : [];

        setThankYouLenders(
          successLenders
            .filter((sl) => sl.lender_id === IIFL_ID || sl.lender_id === MUTHOOT_ID)
            .map((sl) => ({ lender_id: sl.lender_id }))
        );

        const mergedLenders = [
          ...apiLenders.map((l) => ({ ...l, lender_id: l._id })),
          ...successLenders,
        ];

        const lenderMap = Object.fromEntries(
          mergedLenders.map((lender) => [lender.lender_id, lender]),
        );

        const enrichedOffers = offers.map((offer) => {
          const lender = lenderMap[offer.lender_id] || {};
          return {
            ...offer,
            apr: lender.apr ?? "",
            kfs_doc: lender.kfs_doc ?? "",
            credit_limit: lender.web_offer ?? "",
            penal_charges: lender.penal_charges ?? "",
            processing_fee: lender.processing_fee ?? "",
            interest_rate: lender.web_interest ?? null,
            lender_name: lender.lender_name ?? offer.lender_name,
          };
        });

        const sortedOffers = _.orderBy(enrichedOffers, ["priority"], ["asc"]);
        filteredOffers = sortedOffers.filter((offer) =>
          mergedLenders.some((lender) => lender.lender_id === offer.lender_id),
        );
      }

      const elapsedTime = Date.now() - startTime;
      const remainingDelay = Math.max(5000 - elapsedTime, 0);

      setTimeout(() => {
        dispatch(setOffers(filteredOffers));
        setIsLoading(false);
        setIsFinished(true);
      }, remainingDelay);

      return true;
    } catch (err) {
      console.error("Error in offer fetching", err);
      setTimeout(() => {
        setIsLoading(false);
        setIsFinished(true);
      }, 5000);
      return false;
    }
  };

  return (
    <div id="offer-page-v5">
      <ThankYouScreen lenders={thankYouLenders} isLoading={isLoading} />
    </div>
  );
};

export default OfferPage;
